import React from "react";
import styled from "styled-components";
import { COLORS } from "../../COLORS";
type TypeProps = {
  imgPreviewUrl: string;
  pullUpImg: () => void;
};
const PreviewImgCarre = ({ imgPreviewUrl, pullUpImg }: TypeProps) => {
  return (
    <StyledPreviewImgCarre>
      <span>Prévisualisation</span>
      <img src={imgPreviewUrl} alt="img-prévisualisation" />
      <span onClick={() => pullUpImg()} className="pull-img">
        Retirer l'image ?
      </span>
    </StyledPreviewImgCarre>
  );
};

export default PreviewImgCarre;
const StyledPreviewImgCarre = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  span {
    display: block;
    width: 100%;
    margin: 10px 0px;
    color: white;
    text-align: center;
  }
  .pull-img {
    color: ${COLORS.danger};
    cursor: pointer;
  }
  img {
    width: 50%;
  }
  @media screen and (max-width: 445px) {
    img {
      width: 90%;
    }
  }
`;
